import { m } from 'framer-motion';

import { Container, Typography } from '@mui/material';

import { Rule } from 'src/requests/roles.requests';
import { usePermission } from 'src/utils/hasPermission';
import { MotionContainer, varBounce } from '../components/animate';

import { useLocales } from 'src/locales';
import { ForbiddenIllustration } from '../assets/illustrations';
//

type RoleBasedGuardProp = {
  hasContent?: boolean;
  rule?: Rule;
  children: React.ReactNode;
};

export function RoleBasedGuard({
  hasContent,
  rule,
  children,
}: RoleBasedGuardProp) {
  const { hasPermission } = usePermission();
  const { translate } = useLocales();

  if (rule !== undefined && rule !== Rule.MOCK_ALLOW && !hasPermission(rule)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {translate('403_page.no_permission')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {translate('403_page.access_has_restricted')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <> {children} </>;
}

export default RoleBasedGuard;
